module.exports = __webpack_public_path__ + "static/media/next-gen.1d5a24d5.pdf";